var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.ready)?_c(_vm.layout,{tag:"component"},[_c('router-view')],1):_c('div',{directives:[{name:"loading",rawName:"v-loading.fullscreen.lock",value:(true),expression:"true",modifiers:{"fullscreen":true,"lock":true}}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }